import styled from 'styled-components';

export const CardContainer = styled.div`
  width: 328px;
  border-radius: 8px;
  background-color: #FFFFFF;
  box-shadow: 0 2px 6px 0 rgba(0,0,0,0.08), 0 0 1px 0 rgba(0,0,0,0.12);
  padding: 32px;

  //Desktop
  @media only screen and (min-width: 991px) {
    width: 422px;
  }
`;

export const CardTitle = styled.h3`
  padding: 0;
  max-width: 328px;
  margin-bottom: 8px;
  color: #24206B;
  font-family: "Galano Grotesque Alt";
  font-size: 20px;
  letter-spacing: 0;
  line-height: 26px;
  font-weight: normal;

  //Desktop
  @media only screen and (min-width: 991px) {
    width: 422px;
  }
`;

export const CardText = styled.span`
  max-width: 328px;
  color: #110E49;
  font-family: "Open Sans";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 21px;

  //Desktop
  @media only screen and (min-width: 991px) {
    max-width: 422px;
    font-size: 16px;
  }
`;
